// extracted by mini-css-extract-plugin
export var skipAnimation = "_19-0";